import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_DRIVERS = '[SHIPPING GUIDES] GET DRIVERS'
export const GET_SHIPPING_GUIDES = '[SHIPPING GUIDES] GET SHIPPING GUIDES'
export const SAVE_SHIPPING_GUIDE = '[SHIPPING GUIDES] SAVE SHIPPING GUIDE'

export function getDriversAction() {
  const request = api.get('/shipping-guide/drivers')
  return (dispatch) => {
    dispatch({ type: GET_DRIVERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_DRIVERS, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_DRIVERS, error)
    }).finally(() => {
      dispatch({ type: GET_DRIVERS, payload: { loading: false } })
    })
  }
}

export function getShippingGuidesAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/shipping-guides/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SHIPPING_GUIDES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SHIPPING_GUIDES, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_SHIPPING_GUIDES, error)
    }).finally(() => {
      dispatch({ type: GET_SHIPPING_GUIDES, payload: { loading: false } })
    })
  }
}

export function saveShippingGuideAction(data) {
  const request = api.post(`/shipping-guide/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SHIPPING_GUIDE, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SHIPPING_GUIDE, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_SHIPPING_GUIDE, error)
    }).finally(() => {
      dispatch({ type: SAVE_SHIPPING_GUIDE, payload: { saving: false } })
    })
  }
}

export function sendShippingGuideToEmailAction({ shippingGuideId, to }) {
  const request = api.post(`/shipping-guide/send-shipping-guide-to-email`, { shippingGuideId, to })
  return () => {
    toast.info(`Enviando guía a ${to}...`, { toastId: 'sendShippingGuideToEmail', autoClose: false })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message, { toastId: 'sendShippingGuideToEmail' })
        return
      }
      toast.success(response.data.message, { toastId: 'sendShippingGuideToEmail' })
    }).catch((error) => {
      toast.error(error.response?.data?.message ?? 'No se pudo enviar la guía', { toastId: 'sendShippingGuideToEmail' })
      console.log(error)
    }).finally(() => {
      toast.update('sendShippingGuideToEmail', { autoClose: 3000 })
    })
  }
}